function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
import "core-js/modules/es6.array.find-index.js";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.number.constructor.js";
import "core-js/modules/es6.object.define-property.js";
import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es6.object.get-own-property-descriptor.js";
import "core-js/modules/es6.array.for-each.js";
import "core-js/modules/es7.object.get-own-property-descriptors.js";
import "core-js/modules/es6.object.define-properties.js";
import "core-js/modules/es6.string.iterator.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/web.dom.iterable.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ApiService from '../../services/apiService.js';
// import ResizeObserver polfyfill for IE 11 and Edge<19
import { ResizeObserver as ResizeObserverFallback } from '@juggle/resize-observer';
import { vuetifyColors, getContrastYIQ } from '../../utils/themes';
import { mapState, mapGetters } from 'vuex';
import get from 'lodash/get';
import set from 'lodash/set';
export default {
  name: 'CoreAnnouncements',
  computed: _objectSpread(_objectSpread({}, mapState('app', ['announcements'])), mapGetters({
    sessionUser: 'authentication/user',
    tenantId: 'authentication/tenantId'
  })),
  updated: function updated() {
    if (this.$refs.announcementsBanners) {
      // check if browser supports ResizeObserver natively
      if (typeof ResizeObserver === 'function') {
        new ResizeObserver(this.onResizeBannerWrapper).observe(this.$refs.announcementsBanners);
      } else {
        new ResizeObserverFallback(this.onResizeBannerWrapper).observe(this.$refs.announcementsBanners);
      }
    }
  },
  methods: {
    closeAnnouncement: function closeAnnouncement(announcement) {
      var announcementId = announcement.id;
      var userAnnouncements = get(this.sessionUser, 'properties.announcements', []);
      var index = this.$store.state.app.announcements.findIndex(function (announcement) {
        return announcement.id === announcementId;
      });
      this.$store.state.app.announcements.splice(index, 1);
      if (announcementId) {
        set(this.sessionUser, 'properties.announcements', userAnnouncements.filter(function (a) {
          return parseInt(a) !== parseInt(announcementId);
        }));
        this.updateUser(this.sessionUser);
      }
    },
    updateUser: function updateUser(userData, announcement) {
      var _this = this;
      return ApiService.updateUser(userData).then(function () {
        _this.updateAnnouncementState(announcement);
      })["catch"](function (error) {
        console.error(error);
      });
    },
    updateAnnouncementState: function updateAnnouncementState(announcement) {
      return ApiService.tenantUpdateSystemAnnouncementState(this.tenantId, announcement);
    },
    showInfoBanner: function showInfoBanner(announcement) {
      if (!announcement.active || announcement.presentationType !== 'banner') {
        return false;
      }
      var now = new Date();
      var startDate = new Date(announcement.start);
      var endDate = new Date(announcement.end);
      return (announcement.start === null || startDate <= now) && (announcement.end === null || endDate >= now);
    },
    getColor: function getColor(type) {
      return vuetifyColors[type] || vuetifyColors['info'];
    },
    getTextColor: function getTextColor(type) {
      return getContrastYIQ(this.getColor(type), '#333');
    },
    getTypeIcon: function getTypeIcon(type) {
      switch (type) {
        case 'info':
          return 'info-circle';
        case 'success':
          return 'check-circle';
        case 'warning':
          return 'exclamation';
        case 'error':
          return 'exclamation-triangle';
      }
      return 'info-circle';
    },
    onResizeBannerWrapper: function onResizeBannerWrapper() {
      if (this.$refs.announcementsBanners && (this.$refs.announcementsBanners.clientHeight || this.$refs.announcementsBanners.clientHeight === 0)) {
        this.$store.state.app.bannerHeight = this.$refs.announcementsBanners.clientHeight;
      }
    }
  }
};